interface ClockIconProps {
  size?: string;
  color?: string;
}

const ClockIcon = ({ color = "black", size = "12" }: ClockIconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-current"
    >
      <g clipPath="url(#clip0_16778_76970)">
        <path
          d="M8.5 5V8L11 9.5"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6.5H2.5V4"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.725 12.0002C5.51123 12.7421 6.49865 13.2359 7.56389 13.4198C8.62914 13.6037 9.72496 13.4697 10.7144 13.0344C11.7039 12.5991 12.5432 11.8818 13.1274 10.9723C13.7116 10.0627 14.0148 9.00116 13.9991 7.92028C13.9834 6.83939 13.6496 5.78708 13.0393 4.89484C12.429 4.0026 11.5693 3.30999 10.5676 2.90356C9.56588 2.49712 8.46664 2.39487 7.40718 2.6096C6.34771 2.82432 5.37502 3.34649 4.61062 4.11087C3.875 4.85587 3.2675 5.55837 2.5 6.50024"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16778_76970">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
